/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adminStatisticModelSchema } from "../adminStatisticModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiStatisticsQueryParamsSchema = z.object({
    "StartDate": z.string().datetime({ offset: true }).describe("Начальная дата").optional(),
"EndDate": z.string().datetime({ offset: true }).describe("Конечная дата (совпадает (по дате) с начальной при получении статистики за сегодня)").optional(),
"GetForAllTime": z.boolean().describe("Получить за все время").optional()
    }).optional()

/**
 * @description Статистика за период
 */
export const getApiStatistics200Schema = z.lazy(() => adminStatisticModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiStatistics400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiStatistics401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiStatistics403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiStatistics500Schema = z.lazy(() => badResponseModelSchema)

export const getApiStatisticsQueryResponseSchema = z.lazy(() => getApiStatistics200Schema)